import UpdateWidgetHostConfigRequestModelBase from '../_generated/modelBases/update-widget-host-config-request-model-base';

export default class UpdateWidgetHostConfigRequestModel extends UpdateWidgetHostConfigRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
